// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .chooseAll_button_text[data-v-32a1ab7c]{color:grey}", ""]);
// Exports
module.exports = exports;
